import { type Account, Provider } from '@repo/api-gw-sdk';

export const getVaultAccountsForCreation = <
  T extends Pick<Account, 'cloudProvider' | 'isCustomerOwned'>,
>(
  vaultAccounts: T[] | undefined,
  byovEnabled: boolean
) =>
  vaultAccounts?.filter(
    (account) =>
      account.cloudProvider !== Provider.Aws ||
      !account.isCustomerOwned ||
      byovEnabled
  );
